module.exports = __webpack_public_path__ + "img/Employee.ee838ca6.svg";